import { Navigate, Outlet, useLocation } from "react-router-dom";
import permissionConfig from "../components/dashboard/permissionConfig";
import { getAuthRole } from "./authHelpers";

/**
 * RoleGuard — wraps routes that should only be accessible to specific roles.
 *
 * Props:
 *   allowedRoles: string[]  — roles that are permitted to render this route.
 *
 * If the current user's role is not in allowedRoles, they are redirected to
 * the first path allowed by their own permissionConfig entry, or /login.
 */
const RoleGuard = ({ allowedRoles }) => {
  const role = getAuthRole();
  const location = useLocation();

  // SuperAdmin is always allowed through
  if (role === "SuperAdmin") return <Outlet />;

  // Check if this role is explicitly permitted for this route group
  if (allowedRoles && allowedRoles.includes(role)) return <Outlet />;

  // Find what paths this role CAN access and redirect there
  const config = permissionConfig.find((item) => item.role === role);
  const fallback =
    config && config.allowedPaths && config.allowedPaths.length > 0
      ? config.allowedPaths[0]
      : "/login";

  return <Navigate to={fallback} replace state={{ from: location }} />;
};

export default RoleGuard;
